import { Text } from '@chakra-ui/react'
import { storagePage } from '../../storage'
import Card from '../../Components/Card'
import StatBox from '../../Components/StatBox'
import StatCard from '../../Components/StatCard'

export default function Tips() {
    const { cashboxMovements } = storagePage

    const totalTip = cashboxMovements
        .map(i => i.paymentTipWithCardTotalValue)
        .reduce((a, b) => a + b, 0)

    return (
        <Card
            direction="column"
            gridGap={4}
            w={{ base: 'full', md: '100%', lg: '100%' }}
        >
            <Text as="b" mr="2" fontSize="xl" align="center" w="full">
                Propinas
            </Text>
            <StatCard>
                <StatBox
                    label={'Propinas con tarjeta'}
                    value={totalTip}
                    withSymbol={true}
                />
            </StatCard>
        </Card>
    )
}
